/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import DialogModal from "../DialogModal/DialogModal";
import { useNavigate } from "react-router-dom";
import { modalview } from "../../services/useTracker";
import ApiClient from "../../services/apiClient";
import { useCustomer } from "../../provider/Customer/CustomerProvider";
import { Box, Typography } from "@mui/material";

export default function EmailVerificationModal() {
  const navigate = useNavigate();
  const { customer, setRefetchInterval } = useCustomer();

  if (!customer) {
    return null;
  }

  useEffect(() => {
    setRefetchInterval(!customer.verification ? 5000 : false);
  }, [customer.verification]);

  if (!!customer.verification) {
    return null;
  }

  const resendEmail = async () => {
    await ApiClient.post("/resend_welcome_email");
    navigate("/servicewelt");
  };

  if (customer.verification === null) {
    modalview("Email Verification Modal");
  }

  return (
    <DialogModal
      open={true}
      title={"E-Mail-Adresse bestätigen"}
      actions={
        <Button fullWidth={true} variant={"contained"} onClick={resendEmail}>
          Erneut zuschicken
        </Button>
      }
    >
      <Typography paragraph sx={{ textAlign: "left" }}>
        Bitte bestätigen Sie Ihre E-Mail-Adresse. Klicken Sie hierzu einfach auf den Link in der E-Mail, die Sie von uns auf{" "}
        <Box component={"strong"} sx={{ wordBreak: "break-all" }}>{customer.email}</Box> erhalten haben.
      </Typography>
      <Typography paragraph sx={{ textAlign: "left" }}>
        Sie finden die E-Mail nicht? Dann prüfen Sie kurz Ihren SPAM-Ordner, oder schicken Sie sich die E-Mail erneut zu.
      </Typography>
    </DialogModal>
  );
}
